module.exports = __webpack_public_path__ + "images/product_lines/price_icon_develop_bw.png";